<template>
  <span class="blink_me" v-if="!item.stopTime">{{ clock  | formatTime }}</span>
  <span v-else>{{ calculateTime(item)   | formatTimeRoundupSecond  }}</span>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";

export default {
  mixins: [formatterMixin],
  props: {
    item: Object,
  },
  data: () => ({
    clock: "",
    timer: "",
  }),
  computed: {},
  watch: {},
  mounted() {
    this.timer = setInterval(() => {
      this.clock = this.calculateTime(this.item);
    }, 1000);
  },
  beforeDestroy() {
    delete this.timer;
  },
  methods: {
    calculateTime(item) {
      let totalMs = 0;
      let then1 = null;
      if (item.stopTime) {
        then1 = this.momentLocal(item.stopTime);
      } else {
        then1 = this.momentLocal(new Date());
      }
      let now1 = this.momentLocal(item.startTime);
      let ms1 = Math.abs(now1.diff(then1, 'second'));
      totalMs += ms1;
      return parseInt(totalMs);
    },
  },
};
</script>
